export default __webpack_public_path__ + "media/images/features/hida/access-car-fd6619dedbc2a450afc0912afe33ea6b.png";